export const GO_NOW = 'go_now';
export const CONFIRM = 'confirm';
export const NO_REMIND = 'no_remind';
export const SHOWN = 'shown';
